import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { useAppSelector } from '@/redux';
import { selectGuiLoadingState } from '@/redux/slices/gui.slice';

import Icon from '@/components/common/iconedLinks/Icon';
import MillesimaLink from '@/components/common/MillesimaLink';
import ProgressBar from '@/components/common/design-system/ProgressBar.ds';

import styles from './PromoProgress.module.scss';
import { URLS } from '@/constants/urls';

type PromoProgressProps = {
  text: string;
  url: string;
  percentage: number;
  variant?: 'white' | 'grey'
}

export const PromoProgress: FC<PromoProgressProps> = ({ text, url, percentage, variant = 'white' }) => {
  const { t } = useTranslation();
  const loadingState = useAppSelector(selectGuiLoadingState);
  const containerStyle = [
    loadingState && styles['loader-container'],
    !loadingState && styles.container,
    styles[variant]
  ].filter(Boolean).join(' ');

  return loadingState ? (
    <div className={containerStyle}>
      <Icon
        src={URLS.LOADER_BLACK}
        alt={t('alter:loadingIcon')}
        className={styles['loader-image']}
        width={32}
        height={32}
      />
    </div>
  ) : (
    <div className={containerStyle}>
      <div className={styles.header}>
        <p className={styles.text} dangerouslySetInnerHTML={{ __html: text }} />
        <MillesimaLink customClassName={{ link: styles.link }} href={url} >
          {t('btn.addProducts')}
        </MillesimaLink>
      </div>
      <ProgressBar percentage={percentage} />
    </div>
  );
};

export default PromoProgress;
